import React, { useEffect, useState} from 'react';
import { Row, Col, Card, Collapse, Container, Accordion, Badge } from 'react-bootstrap';
import HeaderComponent from './HeaderComponent';
import FeatureNav from './FeatureNav';
import BreadCrumbs from './BreadCrumbs';
import StreamingVideo from './StreamingVideo';

const TransparentUtahHelp = () => {
	const [showHeaderInfo, setShowHeaderInfo] = useState<boolean>(false);
	const [videoError, setVideoError] = useState<string | null>(null);

	const handleVideoError = (videoError: any) => {
		const nativeError = videoError?.target?.error;

		if (nativeError && (nativeError.code === 3 || nativeError.code === 4)) {
    	setVideoError("The video file failed to load.");
	  } 
	}

	// Run Accordion
	useEffect(() => {
    const accordionItems = document.querySelectorAll<HTMLElement>(".custom-accordion-item");

    accordionItems.forEach((item, index) => {
      const header = item.querySelector<HTMLElement>(".custom-accordion-header");
      const content = item.querySelector<HTMLElement>(".custom-accordion-content");
      const icon = header?.querySelector<HTMLElement>("i");

      if (index === 0 && content) {
        item.classList.add("active");
        content.style.display = "block";
        if (icon) {
          icon.classList.remove("fa-plus");
          icon.classList.add("fa-minus");
        }
      }

      header?.addEventListener("click", (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();

        const isActive = item.classList.contains("active");
        item.classList.toggle("active");

        if (content) {
          content.style.display = isActive ? "none" : "block";
        }

        if (icon) {
          icon.classList.toggle("fa-plus", isActive);
          icon.classList.toggle("fa-minus", !isActive);
        }
      });
    });

    const contentDiv = document.querySelector<HTMLElement>(".content");
    if (contentDiv) {
      const allParagraphs = contentDiv.querySelectorAll<HTMLParagraphElement>("p");
      allParagraphs.forEach((p) => {
        if (!p.textContent?.trim() && !p.querySelector("i, span, a")) {
          p.remove();
        }
      });
    }
  }, []);

	return (
		<>
			<HeaderComponent/>
      <FeatureNav/>
      <BreadCrumbs/>
			<Container fluid as="main">
				<Row className="mb-4 px-4">
					<Col xs={12} className="px-0">
						<Card bg="secondary" text="white" style={{ border: "none", borderRadius: "0" }}>
							<Card.Body style={{ justifyItems: "center", textAlign: "center" }}>
								<div className="tu_tabHeader">
									<div className="tu-tabHeader__titleRow">
										<h1 className="tu-tabHeader__title">
										Transparent Utah Help</h1>
											<button
											type="button"
											className="tu-tabHeader__infoBtn"
											onClick={() => setShowHeaderInfo(!showHeaderInfo)}
											aria-label="Transparent Utah Help info"
										>
											<i className="fas fa-info"/>
											</button>
										</div>
									</div>
									<Collapse in={showHeaderInfo}>
										<div>
											<p className="lead mt-2 text-center text-uppercase">
												Utah has been a leader in government transparency since 2009 with a commitment to making it easier for the public to get detailed financial information about state and local government spending. This help section, provides an overview of how the latest version of the website, Transparent Utah 3.4, functions. Below you will find a FAQ, tutorial videos for common searches, and more.
											</p>
										</div>
									</Collapse>
								</Card.Body>
						</Card>
					</Col>
				</Row>

				{/* Help Accordion */}
				<Row className="px-4">
					<section className="content">
						<div className="custom-accordion">
							<div className="custom-accordion-item">
			          <div className="custom-accordion-header">
			            <span className="text-uppercase">What Information is Available? <small className="text-lead fst-italic"> - Note: This section is under construction as we make updates to Transparent Utah - please check back periodically for updated content</small></span>
			            <i className="fa fa-plus"></i>
			          </div>
			          <div className="custom-accordion-content text-uppercase" style={{ display: "none" }} >
			        		There are 16 Information Sections (represented by a graphic tile) on the Transparency home page, color coded into 6 groups.
									<ul>
										{/* Green Badge Section */}
										<li>
											<Badge bg="success" className="mt-2 mb-2">Green</Badge> tiles link to government compensation searches.
											<ul>
												<li>
													<Badge bg="success" className="mt-2 mb-2"><a href="/employees/highest-paid-employees" target="_blank" rel="noopener" className="text-white">Highest Paid Employees</a></Badge> - Find the top 100 highest paid employees at any entity in any fiscal year.
													<div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
								          {videoError ? (
								            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
								              <div className="text-center text-black">
								                <p className="lead">Error: The video failed to load.</p>
								              </div>
								            </div>
									          ) : (
															<StreamingVideo 
																videoFile="highest_paid_employees.mp4" 
																vttFile="highest_paid_employees_video_transcript.vtt" onError={() => handleVideoError(window.event)} autoPlay={false}/>
									          )}
									        </div>
												</li>

												<li>
													<Badge bg="success" className="mt-2 mb-2"><a href="employees/employee-search" target="_blank" rel="noopener" className="text-white">Employee Pay Search</a></Badge> - Find the top 100 highest paid employees at any entity in any fiscal year.
													<div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
								          {videoError ? (
								            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
								              <div className="text-center text-black">
								                <p className="lead">Error: The video failed to load.</p>
								              </div>
								            </div>
									          ) : (
															<StreamingVideo           videoFile="employee_compensation_search_video.mp4"  vttFile="employee_compensation_search_video_transcript.vtt" onError={() => handleVideoError(window.event)}     autoPlay={false}
                              /> 
									          )}
									        </div>
												</li>

												<li>
                          <Badge bg="success" className="mt-2 mb-2"><a href="/entities/compensation-downloader" target="_blank" rel="noopener" className="text-white">Compensation Downloader</a></Badge> - Download all of the employees' compensation under a given entity and fiscal year.
													<div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
								          {videoError ? (
								            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
								              <div className="text-center text-black">
								                <p className="lead">Error: The video failed to load.</p>
								              </div>
								            </div>
									          ) : (
															<StreamingVideo         videoFile="entity_compensation_downloader.mp4" vttFile="entity_compensation_downloader_video_transcript.vtt" onError={() => handleVideoError(window.event)} autoPlay={false}
                              />
									          )}
									        </div>
                         </li>
											</ul>
										</li>

										{/* Grey Badge Section */}
										<li>
											<Badge bg="info" className="mt-2 mb-2">Gray</Badge> Gray tiles provide information on government vendor payments.
											<ul>
												<li>
                          <Badge bg="info" className="mt-2 mb-2"><a href="/entities/highest-paid-vendors" target="_blank" rel="noopener" className="text-white">Highest Paid Vendors</a></Badge>Find the top 100 highest paid vendors and vendor payments for any entity in any fiscal year.
													<div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
														{videoError ? (
									            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
									              <div className="text-center text-black">
									                <p className="lead">Error: The video failed to load.</p>
									              </div>
									            </div>
										          ) : (
																<StreamingVideo
																	videoFile="highest_paid_vendors.mp4"
																	vttFile="highest_paid_vendors_video_transcript.vtt" onError={() => handleVideoError(window.event)}  autoPlay={false}
                                /> 
										          )}
													</div>
                        </li>

												<li>
													<Badge bg="info" className="mt-2 mb-2"><a href="/entities/vendor-payments-search" target="_blank" rel="noopener" className="text-white">Vendor Payment Search</a></Badge>Custom search across all entities and fiscal years for a vendor's payments.
													<div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
														{videoError ? (
									            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
									              <div className="text-center text-black">
									                <p className="lead">Error: The video failed to load.</p>
									              </div>
									            </div>
									          ) : (
															<StreamingVideo
																videoFile="vendor_payments_search.mp4"
															  vttFile="vendor_payments_search_video_transcript.vtt" onError={() => handleVideoError(window.event)} autoPlay={false}
                              /> 
										         )}
													</div>
												</li>
											</ul>
										</li>

										{/* Yellow Badge Section */}
										<li>
											<Badge bg="warning" className="mt-2 mb-2">Yellow</Badge> Yellow titles link to entity information, such as for the state of Utah, a university, school, city, county, or town.
											<ul>
												<li>
													<Badge bg="warning" className="mt-2 mb-2"><a href="/entities/entity-overview-dashboard" target="_blank" rel="noopener" className="text-white">Entity Overview</a></Badge> - Get a quick overview of a government's revenue and expenses.
													<div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
														{videoError ? (
									            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
									              <div className="text-center text-black">
									                <p className="lead">Error: The video failed to load.</p>
									              </div>
									            </div>
									          ) : (
															<StreamingVideo 
                                videoFile="entity_overview.mp4" vttFile="transparent-utah-large-video-bucket/entity_overview_video_transcript.vtt" 
                                onError={() => handleVideoError(window.event)}  autoPlay={false}
                              />
									          )}
													</div>
												</li>

												<li>
													<Badge bg="warning" className="mt-2 mb-2"><a href="https://old.transparent.utah.gov/transaction_details.php" target="_blank" rel="noopener" className="text-white">Transaction Details</a></Badge> - Examine individual transactions in a pivotable table like user interface
													<div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
														{videoError ? (
									            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
									              <div className="text-center text-black">
									                <p className="lead">Error: The video failed to load.</p>
									              </div>
									            </div>
										          ) : (
																<StreamingVideo 
                                  videoFile="transaction-details.mp4" vttFile="transparent-utah-large-video-bucket/transaction_details_video_transcript.vtt" 
                                  onError={() => handleVideoError(window.event)} autoPlay={false}
                                />
										          )}
														</div>
												</li>

												<li>
													<Badge bg="warning" className="mt-2 mb-2"><a href="https://old.transparent.utah.gov/compliance.php" target="_blank" rel="noopener" className="text-white">Compliance Report</a></Badge> - Check which participating entities have submitted data and which are missing reports.
													<div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
														{videoError ? (
									            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
									              <div className="text-center text-black">
									                <p className="lead">Error: The video failed to load.</p>
									              </div>
									            </div>
									          ) : (
															<StreamingVideo 
                                videoFile="compliance_dashboard.mp4" vttFile="compliance_dashboard_video_transcript.vtt" onError={() => handleVideoError(window.event)} autoPlay={false}
                              /> 
									          )}
													</div>
												</li>

												<li>
                          <Badge bg="warning" className="mt-2 mb-2"><a href="/entities/fiscal-distress-dashboard" target="_blank" rel="noopener" className="text-white">Fiscal Distress Dashboard</a></Badge> - Financial distress is the inability of an entity to maintain existing service levels, withstand local and regional economic disruptions, and meet the demands of growth or decline. This dashboard tries to flag early indicators of fiscal distress for all local governments.
                        </li>

												<li>
                          <Badge bg="warning" className="mt-2 mb-2"><a href="https://old.transparent.utah.gov/dqi_dashboard.php" target="_blank" rel="noopener" className="text-white">Data Quality Dashboard</a></Badge> - This dashboard was built to flag errors and quality concerns in Transparency reports submitted to the Office of the State Auditor. Our team has developed algorithms and metrics to pinpoint issues in the data that cause confusion for users of Transparent Utah.
                        </li>
											</ul>
										</li>

										{/* Red Badge Section */}
										<li>
											<Badge bg="danger" className="mt-2 mb-2">Red</Badge> tiles provide access to job title searches.
											<ul>
												<li>
													<Badge bg="danger" className="mt-2 mb-2"><a href="/employees/job-title-search" target="_blank" rel="noopener" className="text-white">Custom Search</a></Badge> - Discover the compensation package for any job using a custom search term.
													<div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
														{videoError ? (
									            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
									              <div className="text-center text-black">
									                <p className="lead">Error: The video failed to load.</p>
									              </div>
									            </div>
										          ) : (
																<StreamingVideo 
                                  videoFile="job_title_search.mp4" vttFile="job_title_search_video_transcript.vtt" onError={() => handleVideoError(window.event)} autoPlay={false}
                                />
										        )}
													</div>
												</li>

												<li>
													<Badge bg="danger" className="mt-2 mb-2"><a href="/employees/highest-paid-jobs" target="_blank" rel="noopener" className="text-white">Highest Paid</a></Badge> - Discover the highest paying jobs in the State and Local governments.
													<div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
														{videoError ? (
									            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
									              <div className="text-center text-black">
									                <p className="lead">Error: The video failed to load.</p>
									              </div>
									            </div>
									          ) : (
															<StreamingVideo videoFile="highest_paid_jobs.mp4" vttFile="highest_paid_jobs_video_transcript.vtt" onError={() => handleVideoError(window.event)} autoPlay={false}/>
									          )}
													</div>
												</li>

												<li>
													<Badge bg="danger" className="mt-2 mb-2"><a href="/employees/most-common-jobs" target="_blank" rel="noopener" className="text-white">Most Common</a></Badge> - Discover the most common (frequency) jobs in the State and Local governments.
													<div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
													{/* Changed to not error as a test */}
													{videoError ? (
								            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
								              <div className="text-center text-black">
								                <p className="lead">Error: The video failed to load.</p>
								              </div>
								            </div>
									          ) : (
															<StreamingVideo videoFile="most_common_jobs.mp4" vttFile="transparent-utah-large-video-bucket/most_common_jobs_video_transcript.vtt" onError={() => handleVideoError(window.event)} autoPlay={false}/>
									          )}
														</div>
												</li>

												<li>
													<Badge bg="danger" className="mt-2 mb-2"><a href="/employees/local-government-jobs" target="_blank" rel="noopener" className="text-white">Wage Trends</a></Badge> - Examine how a given occupation's compensation trends across time.
													<div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
									          {videoError ? (
									            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
									              <div className="text-center text-black">
									                <p className="lead">Error: The video failed to load.</p>
									              </div>
									            </div>
									          ) : (
															<StreamingVideo videoFile="wage_trends.mp4" vttFile="wage_trends_video_transcript.vtt" onError={() => handleVideoError(window.event)} autoPlay={false}/>
									          )}
									        </div>
												</li>

												<li>
													<Badge bg="danger" className="mt-2 mb-2"><a href="/entities/compare-two-entities" target="_blank" rel="noopener" 
													className="text-white">Compare Two Entities</a></Badge> - Compare a job's compensation package between two entities.
													<div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
									          {videoError ? (
									            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
									              <div className="text-center text-black">
									                <p className="lead">Error: The video failed to load.</p>
									              </div>
									            </div>
									          ) : (
															<StreamingVideo videoFile="compare_two_entities.mp4" vttFile="compare_two_entities_video_transcript.vtt" onError={() => handleVideoError(window.event)} autoPlay={false}/>
									          )}
									        </div>
												</li>
											</ul>
										</li>

										{/* Black Badge Section */}
										<li>
											<Badge bg="dark" className="mt-2 mb-2">Black</Badge> tiles indicate connection to the office's Project Kids K-12 Education Spending and Performance Dashboard.
											<ul>
												<li>
													<Badge bg="dark" className="mt-2 mb-2">Project Kids</Badge> - Sister Site - Project Kids is an award-winning, special, in-depth performance audit of public education that integrates financial, operational, and performance data to create interactive visualizations.
												</li>
											</ul>
										</li>
									</ul>
			          </div>
			        </div>

              <div className="custom-accordion-item">
                <div className="custom-accordion-header">
                  <span className="text-uppercase">Quick Search Bar – Detailed search for Employee Pay, Vendor Pay or Job Title - <small className="text-lead fst-italic">Note: This section is under construction as we make updates to Transparent Utah - please check back periodically for updated content</small></span>
                  <i className="fa fa-plus"></i>
                </div>
                <div className="custom-accordion-content text-uppercase" style={{ display: "none" }}>
                  <p className="text-uppercase">At the top of the Transparent Utah page just below the title bar, you will see the Quick Search bar. Use the dropdown menu on the left to select your search topic, then type the appropriate name on the search bar. This is the quickest way to search for an individual government employee, government vendor or job title. Use the dropdown on the left to choose between the search bars.</p>
                  <p className="text-uppercase">The ability to match a specific name, or partial name matches is very powerful and Transparent Utah includes that ability to help you in your searches. The job title quick search can generate large searches, so Transparent Utah provides rich tools on the "Job Title Tools" page.</p>
                  <ul>
                    <li className="mt-3 mb-2">
                      Video Tutorial of Employee Payroll Quick Search
                      <div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
                        {videoError ? (
                          <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
                            <div className="text-center text-black">
                              <p className="lead">Error: The video failed to load.</p>
                            </div>
                          </div>
                        ) : (
                          <StreamingVideo videoFile="employee_compensation_search_video.mp4" vttFile="employee_compensation_search_video_transcript.vtt" onError={() => handleVideoError(window.event)} 
                          autoPlay={false}/>
                        )}
                      </div>
                    </li>
                    
                    <li className="mt-3 mb-2">
                      Video Tutorial of Vendor Payments Quick Search
                      <div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
                        {videoError ? (
                          <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
                            <div className="text-center text-black">
                              <p className="lead">Error: The video failed to load.</p>
                            </div>
                          </div>
                        ) : (
                          <StreamingVideo 
                            videoFile="vendor_payments_search.mp4" vttFile="vendor_payments_search_video_transcript.vtt" onError={() => handleVideoError(window.event)} 
                            autoPlay={false}/>
                        )}
                      </div>
                    </li>

                    <li className="mt-3 mb-2">
                      Video Tutorial of Job Title Quick Search
                      <div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
                        {videoError ? (
                          <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
                            <div className="text-center text-black">
                              <p className="lead">Error: The video failed to load.</p>
                            </div>
                          </div>
                        ) : (
                          <StreamingVideo 
                            videoFile="entity_compensation_downloader.mp4" vttFile="entity_compensation_downloader_video_transcript.vtt" onError={() => handleVideoError(window.event)} autoPlay={false}/>
                        )}
                      </div>
                    </li>

                    <li className="mt-3 mb-2">
                      Entity Compensation Quick Search
                      <div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
                        {videoError ? (
                          <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
                            <div className="text-center text-black">
                              <p className="lead">Error: The video failed to load.</p>
                            </div>
                          </div>
                        ) : (
                          <StreamingVideo videoFile="job_title_search.mp4" vttFile="job_title_search_video_transcript.vtt" onError={() => handleVideoError(window.event)} autoPlay={false}/>
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

							<div className="custom-accordion-item">
			          <div className="custom-accordion-header">
			            <span className="text-uppercase">What is a Fiscal Year?</span>
			            <i className="fa fa-plus"></i>
			          </div>
			          <div className="custom-accordion-content text-uppercase" style={{ display: "none" }}>
			            <p className="text-uppercase">A fiscal year is a governments accounting year - which may or may not follow the calendar year. It is important to remember that the State of Utah and many local government entities, also called "political subdivisions", such as colleges and universities, cities, counties and school districts, have a fiscal year that is not the calendar year.</p>
			            <p className="text-uppercase">The State’s fiscal year starts on July 1 and ends on June 30th. So fiscal year 2024 started on July 1, 2023 and ended on June 30, 2024. Some local government entities have the same fiscal year as the Statem some have a fiscal year that matches the calendar year, others have a completely different fiscal year.</p>
									<p className="text-uppercase">When comparing different entities one entity may include January-December data and the other may include July-June data. Keep this in mind when comparing entity data.</p>
			          </div>
			        </div>

							<div className="custom-accordion-item">
			          <div className="custom-accordion-header">
			            <span className="text-uppercase">What is a Super User?</span>
			            <i className="fa fa-plus"></i>
			          </div>
			          <div className="custom-accordion-content text-uppercase" style={{ display: "none" }}>
			            <p className="text-uppercase">For information on Super Users, please visit our <a href="https://old.transparent.utah.gov/superuser.php" target="_blank" rel="noopener">Super User</a> Page</p>
			          </div>
			        </div>

							<div className="custom-accordion-item">
			          <div className="custom-accordion-header">
			            <span className="text-uppercase">How Regularly is Data Updated?</span>
			            <i className="fa fa-plus"></i>
			          </div>
			          <div className="custom-accordion-content" style={{ display: "none" }}>
			            <p className="text-uppercase">There are two reports entities submit to the Transparent Utah database.</p>
									<ol>
										<li>Quarterly Revenue/Expense Report. Due within 30 days after the end of each quarter. The Quarters are JAN-MAR, APR-JUN, JUL-SEP, and OCT-DEC</li>
										<li>Annual Compensation Report. Due within 90 days of the fiscal year ending.</li>
									</ol>
									<p className="text-uppercase">Please note, that not all entities submit their data on time. This is due to a variety of factors such as forgetting, new employees, or computer/database issues. When entities are late, the Office of the State Auditor notifies the government of our intent to hold or suspend their monies within 60 days. After the 60 days, we then hold or suspend the entity. To see entity compliance statuses you can visit out <a href="https://old.transparent.utah.gov/compliance.php" target="_blank" rel="noopener">Compliance Dashboard</a>.</p>
			          </div>
			        </div>

							<div className="custom-accordion-item">
			          <div className="custom-accordion-header">
			            <span className="text-uppercase">Why is my compensation information visible?</span>
			            <i className="fa fa-plus"></i>
			          </div>
			          <div className="custom-accordion-content text-uppercase" style={{ display: "none" }}>
			            <p className="text-uppercase">If you are an "At-risk Government employee" and your information is visible, please contact Alex Nielson via <a href="mailto:alexnielson@utah.gov">email</a> or phone at <a href="tel:3853554509">385-355-4509</a> to immediately redact your data. Per <a href="https://le.utah.gov/xcode/Title63G/Chapter2/63G-2-S303.html?v=C63G-2-S303_2019051420190514" className="fst-italic">UC Title 63G, Chapter 2, Government Records Access and Management Act. </a>UC Title 63G, Chapter 2, Government Records Access and Management Act. "At-risk government employee" means a current or former:</p>
									<ul>
										<li>peace officer as specified in Section 53-13-102;</li>
										<li>state or federal judge of an appellate, district, justice, or juvenile court, or court commissioner</li>
										<li>judge authorized by Title 39A, Chapter 5, Utah Code of Military Justice;</li>
										<li>judge authorized by Armed Forces, Title 10, United States Code;</li>
										<li>federal prosecutor</li>
										<li>prosecutor appointed pursuant to Armed Forces, Title 10, United States Code;</li>
										<li>law enforcement official as defined in Section 53-5-711;</li>
										<li>prosecutor authorized by Title 39A, Chapter 5, Utah Code of Military Justice; or</li>
										<li>or state or local government employee who, because of the unique nature of the employee's regular work assignments or because of one or more recent credible threats directed to or against the employee, would be at immediate and substantial risk of physical harm if the employee's personal information is disclosed. <span className="fw-bold">Note: The most common redaction under this category is being a victim of domestic violence</span></li>
									</ul>
			          </div>
			        </div>

							<div className="custom-accordion-item">
			          <div className="custom-accordion-header">
			            <span className="text-uppercase">I Have a More Complex Question or Have a Request</span>
			            <i className="fa fa-plus"></i>
			          </div>
			          <div className="custom-accordion-content text-uppercase" style={{ display: "none" }}>
			            <p className="text-uppercase">If you have questions or feedback please contact our team via email <a href="mailto:transparent@utah.gov">transparent@utah.gov</a>. We are always interested in improving our website or making information easier for you to find.</p>
			          </div>
			        </div>
						</div>
					</section>
				</Row>
			</Container>
		</>
	)
}

export default TransparentUtahHelp;